/**
 * Internal dependencies
 */
import Block from './block'
import renderFrontend from '../../util/render-frontend.js'

const getProps = el => ( {
	attributes: JSON.parse( el.dataset.attributes ),
	hasVisibilitySensor: false,
} )

renderFrontend(
	'.wp-block-bwgb-nav-menu__content',
	Block,
	getProps
)
